module.exports = __webpack_public_path__ + "img/home.9385e8de.svg";